import { useEffect, useState } from "react";

const FraudDetailsModal = ({ open, onClose, fraud }) => {

   const [zoomImage, setZoomImage] = useState(null);

  // ✅ HOOK MUST COME FIRST
  useEffect(() => {
    if (open) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [open]);

  // ✅ EARLY RETURN AFTER HOOK
  if (!open || !fraud) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card" style={{ maxHeight: 'calc(100vh - 28px)', width: 'min(920px, 100%)' }}>

        {/* IMAGE */}
        <div className="modal-image" style={{ maxHeight: '300px', overflow: 'hidden' }}>
          {fraud.proofImages && fraud.proofImages.length > 0 ? (
            <img
               src={fraud.proofImages[0]}
               alt="Fraud Proof"
               style={{
               width: "100%",
               maxHeight: "260px",
               objectFit: "contain",
                borderRadius: "8px",
                cursor: "zoom-in"
               }}
                 onClick={() => setZoomImage(fraud.proofImages[0])}
              />
          ) : (
            "Fraudster Image"
          )}
        </div>

        <div className="modal-content">
          <h3>Fraudster Full Details</h3>

          <ul>
            <li><strong>Full Name:</strong> {fraud.fullName}</li>
            <li><strong>Fraud Type:</strong> {fraud.fraudType}</li>

            <li>
              <strong>Fraud Date:</strong>{" "}
              {fraud.fraudDate
                ? new Date(fraud.fraudDate).toLocaleDateString()
                : "-"}
            </li>

            <li>
              <strong>Fraud Location:</strong>{" "}
              {fraud.fraudCity} – {fraud.fraudArea}, {fraud.fraudState}
            </li>

            <li>
              <strong>Aadhaar Location:</strong>{" "}
              {fraud.aadhaarCity} – {fraud.aadhaarArea}, {fraud.aadhaarState}
            </li>

            <li>
              <strong>Phone Number:</strong> {fraud.phoneNumbers?.join(", ")}
            </li>

            <li>
              <strong>Aadhaar Number:</strong> {fraud.aadhaarNumber}
            </li>

            <li>
              <strong>Driving Licence:</strong> {fraud.drivingLicense}
            </li>

            <li>
              <strong>Status:</strong> {fraud.status}
            </li>
          </ul>

          <p className="modal-desc">
            {fraud.description || "No description provided"}
          </p>

          <button className="modal-close" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>

{zoomImage && (
  <div
    className="image-zoom-overlay"
    onClick={() => setZoomImage(null)}
  >
    <img
      src={zoomImage}
      alt="Zoomed Fraud"
      className="zoomed-image"
    />
  </div>
)}


    </div>
  );
};

export default FraudDetailsModal;
